export default [
  {
    name: 'Cards',
    service_id: 1,
    icon: 'fal fa-wallet',
    collapsed: true,
    children: [{
      icon: 'fal fa-chart-pie',
      name: 'Статистика',
      path: '/cards/dashboard',
    }, {
      icon: 'fal fa-table',
      name: 'Данные гостей',
      path: '/cards/registrations',
    }, {
      icon: 'fal fa-credit-card',
      name: 'Карты',
      path: '/cards/cards',
    }, {
      icon: 'fal fa-ghost',
      name: 'Неактивные карты',
      path: '/cards/dead_cards',
    }, {
      name: 'Пуши',
      icon: 'fal fa-bell',
      path: '/cards/push',
    }, {
      name: 'Дизайн карт',
      icon: 'fal fa-palette',
      path: '/cards/card_design',
    }, {
      name: 'Дизайн формы',
      icon: 'fal fa-layer-group',
      path: '/cards/form_design',
    }, {
      name: 'Вопросы & Ответы',
      icon: 'fal fa-question',
      path: '/cards/faq',
    }, {
      name: 'Чёрный список',
      icon: 'fal fa-dizzy',
      path: '/cards/blacklist',
    }, {
      name: 'Настройки',
      icon: 'fal fa-cog',
      path: '/cards/settings',
    }
    ],
  },
  {
    name: 'Cards',
    service_id: 5,
    icon: 'fal fa-wallet',
    collapsed: true,
    free_label: true,
    children: [{
      icon: 'fal fa-chart-pie',
      name: 'Статистика',
      path: '/cards/dashboard_free',
    }, {
      icon: 'fal fa-cog',
      name: 'Базовые настройки',
      path: '/cards/settings_free',
    }, {
      name: 'Пуши',
      icon: 'fal fa-bell',
      path: '/cards/push',
      disabled: true,
    }, {
      name: 'Дизайн карт',
      icon: 'fal fa-palette',
      path: '/cards/card_design',
      disabled: true,
    }, {
      name: 'Дизайн формы',
      icon: 'fal fa-layer-group',
      path: '/cards/form_design',
      disabled: true,
    }, {
      name: 'Вопросы & Ответы',
      icon: 'fal fa-question',
      path: '/cards/faq_free',
    }, {
      name: 'Настройки',
      icon: 'fal fa-cog',
      path: '/cards/settings',
      disabled: true,
    }],
  },


  {
    name: 'SMS Feedback',
    service_id: 2,
    icon: 'fal fa-comment-alt-lines',
    collapsed: true,
    children: [{
      icon: 'fal fa-chart-pie',
      name: 'Ответы гостей',
      path: '/sms_feedback/results',
    }, {
      name: 'Конструктор',
      icon: 'fal fa-cog',
      path: '/sms_feedback/settings',
    }],
  },
  {
    name: 'FindGuest',
    service_id: 3,
    icon: 'fal fa-id-card-alt',
    path: '/findguest',
  },
  {
    name: 'GuestStore',
    service_id: 4,
    icon: 'fal fa-database',
    path: '/gueststore',
  },
  {
    name: 'ChatConnect',
    service_id: 9,
    icon: 'fal fa-comments',
    collapsed: true,
    children: [{
      icon: 'fal fa-keyboard',
      name: 'Чаты',
      path: '/chatconnect/chat',
    }, {
      name: 'Настройки',
      icon: 'fal fa-cog',
      path: '/chatconnect/settings',
    }],
  },
  {
    name: 'ShortLink',
    service_id: 8,
    icon: 'fal fa-external-link-square',
    path: '/sl/settings',
  },
  {
    name: 'QR-Генератор',
    service_id: 7,
    icon: 'fal fa-qrcode',
    path: '/qr',
  },

  {
    name: 'Tobacco Inventory',
    service_id: 11,
    icon: 'fal fa-warehouse-alt',
    collapsed: true,
    children: [{
      icon: 'fal fa-boxes-alt',
      name: 'Склады',
      path: '/inventory/warehouses',
    }, {
      name: 'Поставщики',
      icon: 'fal fa-truck-loading',
      path: '/inventory/suppliers',
    }],
  },

  {
    name: 'Маркетплейс',
    icon: 'fal fa-store',
    path: '/marketplace',
  },
  {
    name: 'Оплата',
    icon: 'fal fa-file-invoice-dollar',
    path: '/pay',
  },
  {
    name: 'Аккаунт',
    icon: 'fal fa-user-cog',
    path: '/account',
  },
  {
    name: 'Telegram Manager',
    icon: 'fal fa-paper-plane',
    path: '/telegram_manager',
    service_id: 10,
  },
  {
    name: 'Админка',
    user_type: [1],
    icon: 'fal fa-user-crown',
    collapsed: true,
    children: [{
      icon: 'fal fa-users',
      name: 'Пользователи',
      path: '/admin/users',
    }, {
      name: 'Транзакции',
      icon: 'fal fa-receipt',
      path: '/admin/transactions',
    }, {
      name: 'Сертификаты карт',
      icon: 'fal fa-file-certificate',
      path: '/admin/cardsCerts',
    }, {
      name: 'Зачисление средств',
      icon: 'fal fa-coins',
      path: '/admin/addmoney',
    }, {
      name: 'Смена пароля',
      icon: 'fal fa-key',
      path: '/admin/change_password',
    }, {
      name: 'Договоры',
      icon: 'fal fa-file-alt',
      path: '/admin/contracts',
      // disabled: true
    }, {
      name: 'Дизайн системы',
      icon: 'fal fa-cog',
      path: '/admin/styles',
    }],
  },
];
